import React from "reactn";
import { StepIndicator } from "../../../components/UI";
import Setup from "./Setup";
import AdditionalDetails from "./AdditionalDetails";
import MembershipPlans from "./MembershipPlans";
// import Customization from "./Customization";
import WaitlistAcceptModal from "../../../components/modals/WaitlistAcceptModal";
import StepBar from "../../../components/UI/StepBar";
import Validators from "../../../validators";
import { canUserCreate } from "../../../utilities/listingCreation";
import axios from "axios";
import { toast } from "react-toastify";
class MembershipSetup extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      step: 0,
      canUserMakeNew: false,
      makeReqMessage: "",
      showWaitlistAcceptModal: false,
      waitlistData: {
        totalSpots: 0,
        currentSpots: 0,
        waitlistedSpots: 0,
        applicationRequired: false
      }
    };
    this.titles = ["Set-Up", "Membership Plans", "Additional Settings"];
    this.validate = [
      () =>
        Validators.Partners.Profile.ValidateMembershipOne(
          this.global.membership
        ),
      () =>
        Validators.Partners.Profile.ValidateMembershipThree(
          this.global.membership
        ),
      () =>
        Validators.Partners.Profile.ValidateMembershipTwo(
          this.global.membership
        )
    ];
    this.steps = [
      { name: "Set-Up", validateFn: this.validate[0] },
      { name: "Membership Plans", validateFn: this.validate[1] },
      { name: "Additional Settings", validateFn: this.validate[2] }
    ];
  }

  async componentDidMount() {
    const canUserMake = await canUserCreate("membership");
    this.setState({
      canUserMakeNew: canUserMake.success,
      makeReqMessage: canUserMake.message
    });

    console.log("MEMBERSHIP PARAM ID", this.props, this.props.match.params);
    if (this.props.match.params.id) {
      console.log("MEMBERSHIP PARAM CASE 1");
      await this.dispatch.getMembership(this.props.match.params.id);
    } else {
      console.log("MEMBERSHIP PARAM CASE 2");
      await this.dispatch.resetEvent();
    }

    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Memberships", to: "/memberships/list" },
        {
          label: this.global.membership.membership_name || "Membership Setup",
          to: this.props.location.pathname.replace(/^\/partners/, "") // remove /partners from pathname
        }
      ]
    });
  }

  /**
   * To be run before saving. If any page is not setup correctly, it will unpublish the page.
   */
  ensureValidPublish = () => {
    // If the page is currently published
    if (this.global.membership.published) {
      // Check validity of all pages
      for (let i = 0; i < this.steps.length; i++) {
        if (this.checkValid(i)) {
          // If any page is invalid, set publish to false
          this.setGlobal({
            membership: {
              ...this.global.membership,
              published: false
            }
          });
          break;
        }
      }
    }
  };

  acceptWaitlist = async () => {
    const { totalSpots, currentSpots, waitlistedSpots } =
      this.state.waitlistData;

    const availableSpots = totalSpots - currentSpots;

    const amountMoved = Math.min(availableSpots, waitlistedSpots);

    if (amountMoved <= 0) {
      console.log("No spots available or no one on waitlist.");
      return;
    }
    let waitlistedUsers = [];
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/partners/memberships/customers/listing/${this.global.membership.id}`
      );
      if (res.data.success) {
        console.log("response", res.data);
        waitlistedUsers = res.data.data
          .filter(item => item.status_stage === "Waitlisted_Unpaid")
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        console.log("waitlistedUsers", waitlistedUsers);
      }
    } catch (err) {
      console.error("Error fetching spots:", err);
      return;
    }

    const usersToAccept = waitlistedUsers.slice(0, availableSpots);
    if (usersToAccept.length === 0) {
      console.log("No waitlisted users to accept.");
      return;
    }
    let successCount = 0;

    for (const user of usersToAccept) {
      console.log("user to accept", user);
      try {
        const ep = `${process.env.REACT_APP_API}/partners/memberships/customers/application_accept/${user.id}`;

        const result = await axios.put(ep, {
          status_stage: "Accepted_Unpaid",
          message: "Automated waitlist acceptance due to increased capacity.",
          childName: user.childName
        });

        if (result.data.success) {
          successCount++;
        }
      } catch (err) {
        console.error(`Failed to process user ${user.id}:`, err);
      }
    }

    if (successCount > 0) {
      toast.success(
        `Successfully accepted ${successCount} users from the waitlist!`
      );
      this.setState({ showWaitlistAcceptModal: false });
    } else {
      toast.error("Failed to process waitlist rollovers.");
    }
  };

  handleSave = async e => {
    const membership = this.global.membership;

    let totalSpots = membership.max_amount || 0;
    let currentSpots = 0;
    let waitlistedSpots = 0;
    let enabledWaitlist = membership.enable_waitlist;
    let applicationRequired = membership.application_required;

    try {
      // Fetch waitlisted spots
      const res = await axios.get(
        `${process.env.REACT_APP_API}/partners/memberships/enrollments/waitlisted/${membership.id}`
      );
      if (res.data.success) {
        waitlistedSpots = res.data.data.count;
      }

      // Fetch current enrolled spots
      const res2 = await axios.get(
        `${process.env.REACT_APP_API}/partners/memberships/enrollments/count/${membership.id}`
      );
      if (res2.data.success) {
        currentSpots = res2.data.data.count;
      }
    } catch (err) {
      console.error("Error fetching spots:", err);
    }

    const showModal =
      enabledWaitlist === true &&
      !applicationRequired &&
      totalSpots > currentSpots &&
      waitlistedSpots > 0;

    // Update both flags and waitlist data in state
    this.setState({
      showWaitlistAcceptModal: showModal,
      waitlistData: {
        totalSpots,
        currentSpots,
        waitlistedSpots,
        applicationRequired
      }
    });
    console.log("waitlistData", this.state.waitlistData);
    return showModal;
  };

  saveProfile = async e => {
    const { step } = this.state;

    this.ensureValidPublish();

    switch (e.target.name) {
      case "next":
        this.setState({ step: step + 1 });
        await this.dispatch.saveMembership();
        break;
      case "back":
        this.setState({ step: step - 1 });
        await this.dispatch.saveMembership();
        break;
      case "save":
        await this.dispatch.saveMembership();
        break;
      default:
        return;
    }
  };

  changePage = async page => {
    this.ensureValidPublish();
    if (!this.checkValid()) {
      // Only allow the user to progress to the earliest invalid page
      for (let i = 0; i < page; i++) {
        if (this.checkValid(i)) {
          return; // Prevent the page from changing
        }
      }
      await this.dispatch.saveMembership();
      this.setState({ step: page });
    } else if (page < this.state.step) {
      // Allow the user to backtrack to previous pages
      await this.dispatch.saveMembership();
      this.setState({ step: page });
    }
  };

  getPage = () => {
    switch (this.state.step) {
      case 0:
        return (
          <Setup
            initialManualInvoices={
              this.props.location.state
                ? this.props.location.state.manualInvoices
                : this.global.membership.manual_invoices
            }
            initialApplicationRequired={
              this.props.location.state
                ? this.props.location.state.applicationRequired
                : this.global.membership.application_required
            }
            allowSameEnrollment={
              this.props.location.state
                ? this.props.location.state.allowSameEnrollment
                : this.global.membership.allowSameEnrollment
            }
          />
        );
      case 1:
        return <MembershipPlans match={this.props.match} />;
      case 2:
        return <AdditionalDetails />;
      default:
        return <Setup />;
    }
  };

  checkValid(step = this.state.step) {
    return this.validate[step] && !this.validate[step]();
  }

  getCompletion() {
    let completed = 0;
    for (let v of this.validate) {
      completed += v();
    }
    return (completed / this.validate.length) * 100;
  }

  render() {
    if (!this.state.canUserMakeNew && !this.props.match.params.id) {
      return (
        <div className="container-fluid">
          {/* Commented out to make space for Top Bar */}
          {/* <div className="cont">
            <h1 className="events-title-header">Memberships</h1>
          </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "50vh",
              alignItems: "center"
            }}
          >
            <p>{this.state.makeReqMessage}</p>
          </div>
        </div>
      );
    }

    return (
      <>
        {this.state.showWaitlistAcceptModal && (
          <WaitlistAcceptModal
            onSubmit={() => {
              this.acceptWaitlist();
              this.saveProfile({ target: { name: "save" } });
            }}
            onManual={() => this.saveProfile({ target: { name: "save" } })} // New prop for manual
            onClose={_ => this.setState({ showWaitlistAcceptModal: false })}
            totalSpots={this.state.waitlistData.totalSpots} // total program spots
            currentSpots={this.state.waitlistData.currentSpots} // currently enrolled
            waitlistedSpots={this.state.waitlistData.waitlistedSpots} // waitlisted count
            applicationRequired={this.state.waitlistData.applicationRequired} // true/false
          />
        )}
        <div className="container-fluid">
          {/* Commented out to make space for Top Bar */}
          {/* <div className="cont">
          <h1 className="events-title-header">Memberships</h1>
        </div> */}
          <StepBar
            {...{
              steps: this.steps,
              changeFn: this.changePage,
              current: this.state.step
            }}
          />
          <StepIndicator value={this.getCompletion()} />
          {this.getPage()}
          <div className="cont mb-5">
            <div
              className="buttons w-100"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "80%"
                }}
              >
                <div
                  name="back"
                  disabled={this.state.step === 0}
                  style={{
                    transform:
                      window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                    display: "inline-block",
                    transformOrigin: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  onClick={e => {
                    e.target.name = "back";
                    if (this.state.step === 0) return;
                    this.saveProfile(e);
                  }}
                >
                  <i
                    name="back"
                    style={{
                      paddingRight: window.innerWidth < 768 ? "20px" : "24px"
                    }}
                    className={`fas fa-chevron-left ${
                      this.state.step === 0
                        ? "listing-step-btn-inactive"
                        : "listing-step-btn-active"
                    }`}
                  ></i>
                </div>
                <div
                  name="next"
                  onClick={e => {
                    e.target.name = "next";
                    if (
                      this.state.step === this.titles.length - 1 ||
                      this.checkValid()
                    )
                      return;
                    this.saveProfile(e);
                  }}
                  style={{
                    transform:
                      window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                    display: "inline-block",
                    transformOrigin: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i
                    name="next"
                    style={{
                      paddingLeft: window.innerWidth < 768 ? "20px" : "24px"
                    }}
                    className={`fas fa-chevron-right ${
                      this.state.step === this.titles.length - 1 ||
                      this.checkValid()
                        ? "listing-step-btn-inactive"
                        : "listing-step-btn-active"
                    }`}
                  ></i>
                </div>
              </div>
              {/* <button
              onClick={this.saveProfile}
              disabled={this.state.step === 0}
              name="back"
              className="nextbtn"
            >
              BACK
            </button> */}
              <div
                style={{
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end"
                }}
              >
                {this.state.step === this.titles.length - 1 && (
                  <button
                    onClick={_ => {
                      this.setGlobal(
                        {
                          membership: {
                            ...this.global.membership,
                            published: !this.global.membership.published
                          }
                        },
                        _ => this.dispatch.saveMembership()
                      );
                    }}
                    name="save"
                    className={
                      this.checkValid() ? "nextbtnDisabled" : "nextbtn"
                    }
                    disabled={this.checkValid()}
                    style={{
                      transform:
                        window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                      display: "inline-block",
                      transformOrigin: "right"
                    }}
                  >
                    {this.global.membership.published ? "Unpublish" : "Publish"}
                  </button>
                )}
                <button
                  onClick={async e => {
                    console.log(
                      "this.global.membership",
                      this.global.membership
                    );
                    const target = e.currentTarget;
                    const showModal = await this.handleSave();

                    if (!showModal) {
                      target.name = "save";
                      this.saveProfile({ target: { name: "save" } });
                    }
                  }}
                  disabled={this.checkValid()}
                  name="save"
                  className="savebtn"
                  style={{
                    background: "#b2b8c7",
                    border: "1px solid #b2b8c7",
                    transform:
                      window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                    display: "inline-block",
                    transformOrigin: "right"
                  }}
                >
                  SAVE
                </button>
              </div>
              {/* <button
              onClick={this.saveProfile}
              disabled={
                this.state.step === this.titles.length - 1 || this.checkValid()
              }
              name="next"
              className="nextbtn"
            >
              NEXT
            </button> */}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default MembershipSetup;
